import { render } from "./GalleryApp.vue?vue&type=template&id=0982d888&ts=true"
import script from "./GalleryApp.vue?vue&type=script&lang=ts"
export * from "./GalleryApp.vue?vue&type=script&lang=ts"

import "./GalleryApp.vue?vue&type=style&index=0&id=0982d888&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__